import "../Css/Movie.css";
// import Notfoundpage from "../Components/Notfoundpage";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Movie(props) {
//   function pageerror() {
//     window.open(<Notfoundpage />, " ", "width=1000,height=1000");
//   }
  useEffect(() => {
    Aos.init({ duration: 5000, transtiton: "2.3s all" });
  }, []);

  return (
    <div className="col-md-2 mocol">
   
        {/* <span
          id="Movie"
          onClick={() => {
            pageerror();
          }}
        > */}
          <img id="moimg" src={props.img} alt="" />
          <p>{props.title}</p>
          <p>Year:{props.Year}</p>
        {/* </span> */}

    </div>
  );
}
export default Movie;
